import { render } from "./nestedDraggable.vue?vue&type=template&id=80a6b930&scoped=true"
import script from "./nestedDraggable.vue?vue&type=script&lang=js"
export * from "./nestedDraggable.vue?vue&type=script&lang=js"

import "./nestedDraggable.vue?vue&type=style&index=0&id=80a6b930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a6b930"]])

export default __exports__